import { application } from "./application"

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import MobilenavController from "./mobilenav_controller"
application.register("mobilenav", MobilenavController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import MapLoaderController from "./map_loader_controller"
application.register("map-loader", MapLoaderController)

import AirportAutocompleteController from "./airport_autocomplete_controller"
application.register("airport-autocomplete", AirportAutocompleteController)
